import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper, Box, GridProps, PaperProps, BoxProps, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import { TelemetryEvents } from '@monorepo/shared/src/types';

type Props = GridProps &
  PropsWithChildren<{
    title?: string;
    link?: string;
    paperProps?: PaperProps & { href?: string; from?: string };
    boxProps?: BoxProps;
    sendEvent?: boolean;
    newWindow?: boolean;
  }>;

const HomeGridCard: React.FC<Props> = ({
  children,
  link,
  title,
  sendEvent,
  newWindow,
  paperProps,
  boxProps,
  ...gridProps
}) => {
  const navigate = useNavigate();
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.ACCESS_LINK);
  const classes = useStyles({ link });

  const handleClick = () => {
    if (link && title) {
      if (newWindow) window.open(link, '_blank');
      else navigate(link);
      if (!sendEvent) return;
      fireEvent({ link: title, route: RouteSource.DASHBOARD });
    }
  };

  return (
    <Grid item {...gridProps}>
      <Link onClick={handleClick} className={classes.buttonLike}>
        <Paper style={{ display: 'flex', flex: 1 }} {...paperProps} elevation={4}>
          <Box display="flex" flexDirection="column" flex={1} m={2} {...boxProps}>
            {children}
          </Box>
        </Paper>
      </Link>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  buttonLike: (props: any) => ({
    textDecoration: 'none !important',
    cursor: props.link ? 'pointer' : '',
  }),
}));

export default HomeGridCard;
